export default {
  bindings: {
    code: '<',
    id: '<'
  },
  controller: 'paymentConnectController',
  template: require('../views/payment.connect.html')
};
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/components/payment.connect.component.js